import { useNavigate } from "react-router";

import { DropdownAction } from "@/components/organisms/DropdownAction";
import { EditIcon } from "@/components/atoms/icons";
import { IMaterial } from "@/config/models/materials.types";
import { PathNamekAppsRoutes, PathNamekRoutes } from "@/router";

import { ActionDeleteItem } from "./ActionDeleteItem";

type MaterialActionsProps = {
  material: IMaterial;
};

export function MaterialActions({ material }: MaterialActionsProps) {
  const navigate = useNavigate();

  const onClickEdit = () => {
    navigate(`/${PathNamekAppsRoutes.CONFIG}/${PathNamekRoutes.CONFIG.MATERIALS}/${material.id}`);
  };

  return (
    <>
      <DropdownAction>
        <DropdownAction.Item icon={<EditIcon />} label="Editar" onClick={onClickEdit} />

        <ActionDeleteItem material={material} />
      </DropdownAction>
    </>
  );
}
